import { Dayjs } from 'dayjs';
import { PickersCalendarHeaderProps } from '@mui/x-date-pickers/PickersCalendarHeader';

import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/system';

import { useStore } from 'src/context/StoreContext';

import { typographyfontTextHeader } from 'src/components/calendar/styles';

const CustomCalendarHeader = (props: PickersCalendarHeaderProps<Dayjs> & { getDayAvalid?: (yearMonth: string) => void }, sx?: SxProps<Theme>) => {
  const { currentMonth, onMonthChange, getDayAvalid } = props;
  const storeContext = useStore();
  const store = storeContext.store;

  const selectNextMonth = () => {
    const newMonth = currentMonth.add(1, 'month');

    if (getDayAvalid) {
      getDayAvalid(newMonth.format('YYYY-MM'));
    } else {
      onMonthChange(newMonth, 'left')
    }
  };

  const selectPreviousMonth = () => {
    const newMonth = currentMonth.subtract(1, 'month');

    if (getDayAvalid) {
      getDayAvalid(newMonth.format('YYYY-MM'));
    } else {
      onMonthChange(newMonth, 'right')
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center',
      height: '41px',
      alignItems: 'center',
      borderRadius: '4px 4px 0px 0px',
      ...props.sx
    }}>
      <Stack direction='row' spacing={1}>
        <IconButton onClick={selectPreviousMonth} title='Previous month'>
          <img src='/images/ic-arrow-left-gray.svg' style={{ width: '24px', height: '24px' }} alt='icon' />
        </IconButton>
      </Stack>
      <Typography variant='body2' sx={{ ...typographyfontTextHeader, color: store.palette.calendar.text.color, mx: '5px' }}>
        {currentMonth.format('YYYY')}年{currentMonth.format('M')}月
      </Typography>
      <Stack spacing={1} direction='row'>
        <IconButton onClick={selectNextMonth} title='Next month'>
          <img src='/images/ic-arrow-right-gray.svg' style={{ width: '24px', height: '24px' }} alt='icon' />
        </IconButton>
      </Stack>
    </Box>
  );
}

export default CustomCalendarHeader;